import type { SetupChecklistStep } from 'pages/cashFlow/types'

export const SETUP_WIDGET_STEPS = ['direct_payment', 'payments', 'milestones', 'invoicing', 'accounting']

const widgetStepSortKey = (internalName: string) => {
  const i = SETUP_WIDGET_STEPS.indexOf(internalName)
  return i === -1 ? SETUP_WIDGET_STEPS.length : i
}

type SetupChecklistMergeableStep = Pick<SetupChecklistStep, 'internal_name' | 'status'>

/**
 * Merges required + optional checklist steps for the hub widget, keeping one row per internal_name.
 * Duplicate DB rows (e.g. two ``payments`` checkpoints for the same country) would otherwise render twice.
 */
export function mergeSetupChecklistWidgetSteps<T extends SetupChecklistMergeableStep>(
  checklistData: {
    required_steps?: T[] | undefined
    optional_steps?: T[] | undefined
  }
): T[] {
  const required = checklistData.required_steps ?? []
  const optional = checklistData.optional_steps ?? []
  const seen = new Set<string>()
  const merged: T[] = []
  for (const step of [...required, ...optional]) {
    if (!SETUP_WIDGET_STEPS.includes(step.internal_name)) continue
    if (seen.has(step.internal_name)) continue
    seen.add(step.internal_name)
    merged.push(step)
  }
  merged.sort((a, b) => widgetStepSortKey(a.internal_name) - widgetStepSortKey(b.internal_name))
  return merged
}
